export default "__VITE_ASSET__D06dbTC2__"